import { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import FloatingLogo from "../components/FloatingLogo";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PayPalDonate from "../components/PayPalDonate";
import { Styles } from "../styles/styles";
import routes from "./config";

const Router = () => {
	return (
		<Suspense fallback={null}>
			<Styles />
			<FloatingLogo />
			<PayPalDonate />
			<Header />
			<Switch>
				{routes.map((routeItem) => {
					return (
						<Route
							key={routeItem.component}
							path={routeItem.path}
							exact={routeItem.exact}
							component={lazy(
								() => import(`../pages/${routeItem.component}`),
							)}
						/>
					);
				})}
			</Switch>
			<Footer />
		</Suspense>
	);
};

export default Router;
